import { FunctionComponent } from "react";

import { faBolt } from "@fortawesome/pro-regular-svg-icons";

import { Toggle } from "@/components/Toggle/Toggle";
import { Icon } from "@/components/Icon/Icon";
import { Tooltip } from "@/components/Tooltip/Tooltip";

interface GenerateBarTogglesProps {
	batchMode: boolean;
	setBatchMode: (v: boolean) => void;
	batchSize: number;
	isGenerating: boolean;
	linkedinInviteNote: boolean;
	setLinkedinInviteNote: (v: boolean) => void;
	linkedinInviteNoteDisabled?: boolean;
	/** Why the note is off: the sender is connected, or on LinkedIn Free (PREC-4303). */
	linkedinInviteNoteTooltip?: string | null;
	creditCount: number;
	/** Hide the multi-lead "Create drafts for the next N leads" toggle (single-lead chat). */
	hideBatchMode?: boolean;
}

export const GenerateBarToggles: FunctionComponent<GenerateBarTogglesProps> = ({
	batchMode,
	setBatchMode,
	batchSize,
	isGenerating,
	linkedinInviteNote,
	setLinkedinInviteNote,
	linkedinInviteNoteDisabled,
	linkedinInviteNoteTooltip,
	creditCount,
	hideBatchMode,
}) => {
	const inviteNoteRow = (
		<div className="flex items-center gap-2">
			<Toggle
				disabled={isGenerating || linkedinInviteNoteDisabled}
				isChecked={linkedinInviteNote}
				onChange={() => setLinkedinInviteNote(!linkedinInviteNote)}
			/>
			<span className={`text-sm ${linkedinInviteNoteDisabled ? "text-text-meta" : "text-text"}`}>
				Add note to LinkedIn invite
			</span>
		</div>
	);

	return (
		<div className="flex flex-col items-start gap-4">
			{/* Add note to LinkedIn invite + credits */}
			<div className="flex items-center gap-4 w-full">
				{linkedinInviteNoteTooltip ? (
					<Tooltip content={linkedinInviteNoteTooltip}>{inviteNoteRow}</Tooltip>
				) : (
					inviteNoteRow
				)}

				<div className="flex items-center gap-1 text-xs text-text-meta ml-auto">
					<Icon className="w-3 h-3 text-yellow-500" icon={faBolt} />
					<span>
						{creditCount} credit{creditCount > 1 ? "s" : ""}
					</span>
				</div>
			</div>

			{/* Batch mode toggle — omitted in the single-lead Chat tab (no lead queue) */}
			{!hideBatchMode && (
				<div className="flex items-center gap-2">
					<Toggle
						disabled={isGenerating}
						isChecked={batchMode}
						onChange={() => setBatchMode(!batchMode)}
					/>
					<span className="text-sm text-text-meta">
						Create drafts for the next {batchSize} lead{batchSize > 1 ? "s" : ""}
					</span>
				</div>
			)}
		</div>
	);
};
